module.exports = __webpack_public_path__ + "img/wwga.4bb29199.png";